import { useState } from 'react';
import { Button, Card, Col, Form } from 'react-bootstrap';
import ErrorComponent from '../../../Components/ErrorMessage';
import { replacePlaceholder } from '../../../Utils/Utils';
import './npsselection.css'
const NPSQuestion = ({ question, handleChange, formValues, showError }) => {
  const isMandatory = question.isMandatory;
  const questionText = replacePlaceholder(question.questionText, formValues);

  // Get current value from formValues
  const currentValue = formValues[question.tempId] || null;
  const hasAnswer = currentValue !== null;

  const npsData = [
    { value: '0', className: ' btn-danger margin-right', text: 'Not at all likely' },
    { value: '1', className: ' btn-danger margin-right', text: '' },
    { value: '2', className: ' btn-danger margin-right', text: '' },
    { value: '3', className: ' btn-danger margin-right', text: '' },
    { value: '4', className: ' btn-danger margin-right', text: '' },
    { value: '5', className: ' btn-danger margin-right', text: '' },
    { value: '6', className: ' btn-danger margin-right', text: '' },
    { value: '7', className: ' btn-warning margin-right', text: '' },
    { value: '8', className: ' btn-warning margin-right', text: '' },
    { value: '9', className: ' btn-success margin-right', text: '' },
    { value: '10', className: ' btn-success margin-right', text: 'Extremely likely' }
  ];

  const handleNPSSelection = (value) => {
    handleChange({
      target: {
        name: question.tempId,
        value: value
      }
    });
  };

  return (
    <Card className={`mt-3 ${isMandatory && showError && !hasAnswer ? "border-danger" : ""}`}>
      <Card.Body>
        <Form>
          <Form.Group controlId={question.tempId}>
            <div className="d-flex flex-column">
              <Form.Label>
                <b className="preserve-text">
                  {question.tempId}.{questionText}
                  {isMandatory && <span className="text-danger">*</span>}
                </b>
              </Form.Label>
              <Form.Label>
                <b style={{ color: 'lightblue' }}>{question.questionDescription}</b>
              </Form.Label>
              {isMandatory && showError && !hasAnswer && (
                <ErrorComponent message={question.requiredErrorText} />
              )}
            </div>
          <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
  <p style={{ fontWeight: 'bold', width: '30%', textAlign: 'left' }}>
    {question.minLabel || 'Not at all likely'}
  </p>
  <p style={{ width: '50%' }}></p>
  <p style={{ fontWeight: 'bold', width: '30%', textAlign: 'right' }}>
    {question.maxLabel || 'Extremely likely'}
  </p>
</div>

<div className="nps-wrapper">
  {/* Left Spacer */}
  <div className="nps-spacer" />

  {/* NPS Buttons */}
 <div className="nps-container">
  {npsData.map(({ value, className }) => (
    <div key={value} className="nps-button-wrapper">
      <Button
        className={`btn ${className} ${currentValue === value ? 'selected selected-light-blue' : ''}`}
        onClick={() => handleNPSSelection(value)}
      >
        {value}
      </Button>
    </div>
  ))}
</div>

  {/* Right Spacer */}
  <div className="nps-spacer" />
</div>


          </Form.Group>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default NPSQuestion;
